import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";

const Layout = ({ children }) => {
  return (
    <div className="tracking-wide w-full h-screen p-0 m-0">
      <Header />
      <section className="pt-[80px]">{children}</section>
      <Sidebar />
    </div>
  );
};

export default React.memo(Layout);
